<template>
  <!-- Componente principal de la página Home -->
  <div class="home">
    <!-- 1. Deslizador de marcas: bucle infinito de logos -->
    <div class="brand-marquee">
      <div class="marquee-track">
        <!-- Duplicamos tres imágenes para que el desplazamiento sea continuo -->
        <img
          src="@/assets/images/logos/banner-marcas-rodasep.webp"
          alt="Marcas Rodasep"
        />
        <img
          src="@/assets/images/logos/banner-marcas-rodasep-2.webp"
          alt="Marcas Rodasep"
        />
        <img
          src="@/assets/images/logos/banner-marcas-rodasep-3.webp"
          alt="Marcas Rodasep"
        />
        <!-- Segundo set idéntico al primero -->
        <img
          src="@/assets/images/logos/banner-marcas-rodasep.webp"
          alt="Marcas Rodasep"
        />
        <img
          src="@/assets/images/logos/banner-marcas-rodasep-2.webp"
          alt="Marcas Rodasep"
        />
        <img
          src="@/assets/images/logos/banner-marcas-rodasep-3.webp"
          alt="Marcas Rodasep"
        />
      </div>
    </div>

    <!-- 2. Carrusel principal de banners (Bootstrap) -->
    <div
      id="bannerCarousel"
      ref="banner"
      class="carousel slide carousel-fade"
      data-bs-ride="carousel"
      :data-bs-interval="slideInterval"
      data-bs-wrap="true"
      data-bs-pause="false"
    >
      <!-- Indicadores numéricos -->
      <div class="carousel-indicators">
        <button
          v-for="(s, i) in slides"
          :key="i"
          type="button"
          data-bs-target="#bannerCarousel"
          :data-bs-slide-to="i"
          :class="{ active: i === 0 }"
          :aria-current="i === 0 ? 'true' : null"
          :aria-label="`Slide ${i + 1}`"
        ></button>
      </div>

      <!-- Elementos del carrusel -->
      <div class="carousel-inner">
        <div
          v-for="(s, i) in slides"
          :key="i"
          :class="['carousel-item', { active: i === 0 }]"
        >
          <img
            :src="require(`@/assets/images/banners/${s.image}`)"
            class="d-block w-100"
            alt="Banner"
            style="height: 65vh; object-fit: cover"
          />
          <div class="carousel-caption d-block">
            <h3>{{ s.title }}</h3>
            <p>{{ s.subtitle }}</p>
          </div>
        </div>
      </div>

      <!-- Controles de navegación -->
      <button
        class="carousel-control-prev"
        type="button"
        data-bs-target="#bannerCarousel"
        data-bs-slide="prev"
      >
        <span class="carousel-control-prev-icon"></span>
        <span class="visually-hidden">Anterior</span>
      </button>
      <button
        class="carousel-control-next"
        type="button"
        data-bs-target="#bannerCarousel"
        data-bs-slide="next"
      >
        <span class="carousel-control-next-icon"></span>
        <span class="visually-hidden">Siguiente</span>
      </button>
    </div>

    <!-- 4. Tarjetas de Industrias con efecto hover -->
    <section class="cards-section my-5">
      <h2 class="text-center mb-4">Nuestras Áreas de Servicio</h2>
      <div class="cards-wrapper">
        <div class="container">
          <!-- Card 1: Agrícola -->
          <div class="card">
            <div class="face face1">
              <div class="content">
                <h2>Sector Agrícola</h2>
                <p>
                  Ofrecemos soluciones especializadas para el sector agrícola,
                  con rodamientos de alta calidad diseñados para resistir
                  condiciones adversas y maximizar el rendimiento de su
                  maquinaria.
                </p>
              </div>
            </div>
            <div class="face face2 agricola-bg">
              <h2>Agrícola</h2>
            </div>
          </div>

          <!-- Card 2: Automotriz -->
          <div class="card">
            <div class="face face1">
              <div class="content">
                <h2>Sector Automotriz</h2>
                <p>
                  Contamos con un amplio catálogo de rodamientos y repuestos
                  para vehículos de todas las marcas, garantizando durabilidad y
                  precisión en cada componente.
                </p>
              </div>
            </div>
            <div class="face face2 automotriz-bg">
              <h2>Automotriz</h2>
            </div>
          </div>

          <!-- Card 3: Industrial -->
          <div class="card">
            <div class="face face1">
              <div class="content">
                <h2>Sector Industrial</h2>
                <p>
                  Nuestra experiencia en el sector industrial nos permite
                  ofrecer soluciones personalizadas para cualquier tipo de
                  maquinaria, con asesoría técnica especializada.
                </p>
              </div>
            </div>
            <div class="face face2 industrial-bg">
              <h2>Industrial</h2>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Sección de texto grande con rodamiento  -->
    <section id="seccion-reveal" class="scroll-reveal-section">
      <div class="marquee-container">
        <!-- Logo RODASEP -->
        <div class="logo-container">
          <div class="logo-main">
            <span class="logo-text">R</span>
            <img
              :src="require('@/assets/images/logos/rodamiento.png')"
              alt="Rodamiento"
              class="marquee-png"
            />
            <span class="logo-text">D A S E P</span>
            <span class="logo-registered">®</span>
          </div>
          <div class="logo-tagline">
            <span>Especialistas en Rodamientos</span>
          </div>

          <!-- Nube de etiquetas para los productos -->
          <div class="tag-cloud">
            <a href="#" class="tag tag-medium tag-4">Bicicleta</a>
            <a href="#" class="tag tag-large tag-1">Rodamientos</a>
            <a href="#" class="tag tag-medium tag-2">Retenes</a>
            <a href="#" class="tag tag-small tag-3">Soportes</a>
            <a href="#" class="tag tag-medium tag-4">Cajas</a>
            <a href="#" class="tag tag-xlarge tag-5">Manguitos</a>
            <a href="#" class="tag tag-large tag-6">Cadenas</a>
            <a href="#" class="tag tag-medium tag-7">Correas de trasmision</a>
            <a href="#" class="tag tag-small tag-8">Crucetas</a>
            <a href="#" class="tag tag-medium tag-9">Piñones</a>
            <a href="#" class="tag tag-large tag-10"
              >Rodamientos autocentrantes</a
            >
            <a href="#" class="tag tag-medium tag-11">Ruedas industriales</a>
            <a href="#" class="tag tag-small tag-12">Acoplamientos</a>
            <a href="#" class="tag tag-xlarge tag-13">Cintas Transportadoras</a>
            <a href="#" class="tag tag-medium tag-14">Uniones</a>
            <a href="#" class="tag tag-large tag-15">Poleas</a>
            <a href="#" class="tag tag-small tag-16">Bushing</a>
            <a href="#" class="tag tag-medium tag-17"
              >Neumatica y Automatizacion</a
            >
            <a href="#" class="tag tag-xlarge tag-18">Motores electricos</a>
            <a href="#" class="tag tag-large tag-19">Motorreductores</a>
            <a href="#" class="tag tag-medium tag-20">Sellos Mecanicos</a>
            <a href="#" class="tag tag-small tag-21">Lubricantes</a>
            <a href="#" class="tag tag-medium tag-22">Selladores</a>
            <a href="#" class="tag tag-large tag-23">Seguros segers</a>
            <a href="#" class="tag tag-medium tag-24">Arandelas</a>
            <a href="#" class="tag tag-small tag-25">O-Rings</a>
          </div>
        </div>
      </div>
    </section>

    <!-- Sección del catálogo tipo libro con mayor separación superior -->
    <section
      id="catalogo-section"
      class="catalogo-section"
      ref="catalogoSection"
    >
      <div class="catalog-title-container">
        <h2 class="catalog-title">Revisa nuestro catálogo</h2>
        <div class="catalog-separator">
          <span class="catalog-icon"><i class="fas fa-book-open"></i></span>
        </div>
      </div>
      <div class="catalogo-container" ref="catalogoContainer">
        <div class="book-shadow"></div>
        <div class="book-container">
          <iframe
            src="/docs/catalogo-rodasep-v1.pdf"
            class="pdf-viewer"
            title="Catálogo Rodasep"
            frameborder="0"
            allowfullscreen
          ></iframe>
          <!-- Eliminamos las esquinas blancas -->
        </div>
      </div>
    </section>

    <!-- Botón flotante de WhatsApp -->
    <a
      href="https://wa.me/56968748210?text=Hola%20me%20comunico%20a%20través%20de%20Rodasep%20Web:"
      class="whatsapp-float"
      :class="{ 'avoid-footer': avoidFooter }"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
    >
      <img
        :src="require('@/assets/images/logos/click-whatsapp.png')"
        alt="WhatsApp"
        class="whatsapp-icon"
      />
    </a>
    <AsistenteVirtual />
  </div>
</template>

<script>
import "@/assets/css/scroll_effects/scroll_reveal.css";
import "@/assets/css/tags_clouds/tags-home.css"; // etiquetas flotantes
import AsistenteVirtual from "@/components/AsistenteVirtual.vue";

export default {
  name: "RodasepHome",
  components: {
    AsistenteVirtual,
  },

  data() {
    return {
      /* ⏱ intervalo para el carrusel (usado en el template vía
         :data-bs-interval="slideInterval") */
      slideInterval: 5000,

      slides: [
        {
          image: "banner-cuatro.webp",
          title: "Rodamientos de alta calidad",
          subtitle: "Los mejores repuestos industriales",
        },
        {
          image: "rodasep-banner-hd-edit.webp",
          title: "Visítanos en nuestras sedes",
          subtitle: "Curicó, Linares y Talca a tu servicio",
        },
        {
          image: "banner-dos.webp",
          title: "Repuestos para maquinaria pesada",
          subtitle: "Atención personalizada y stock permanente",
        },
        {
          image: "banner-uno.webp",
          title: "Multiples áreas de servicios",
          subtitle: "Eficiencia certificada para cada industria",
        },
        {
          image: "banner-tres-edit.webp",
          title: "Asesoría técnica experta",
          subtitle: "Confía en nuestro equipo especializado",
        },
      ],
      catalogoVisible: false,
      avoidFooter: false,
    };
  },

  mounted() {
    /* La Data-API de Bootstrap se encarga de iniciar el carrusel
       gracias a los atributos data-bs-* del template. */

    this.initScrollEffect();
    this.initCatalogoObserver();

    // observamos el footer (para el botón de WhatsApp) cuando exista
    setTimeout(() => this.observeFooter(), 200);
  },

  beforeUnmount() {
    if (this.scrollHandler)
      window.removeEventListener("scroll", this.scrollHandler);
    if (this.catalogoObserver) this.catalogoObserver.disconnect();
    if (this.footerObserver) this.footerObserver.disconnect();
  },

  methods: {
    /* ---------- desplazamiento parallax de los rieles ---------- */
    initScrollEffect() {
      this.scrollHandler = () => {
        const pos = window.scrollY;
        const top = document.querySelector(".scroller-top");
        const bot = document.querySelector(".scroller-bottom");
        if (top && bot) {
          top.style.transform = `translateX(-${pos * 0.2}px)`;
          bot.style.transform = `translateX(${pos * 0.2}px)`;
        }
      };
      window.addEventListener("scroll", this.scrollHandler);
    },

    /* ---------- animación del “libro” catálogo ---------- */
    initCatalogoObserver() {
      const options = { root: null, rootMargin: "0px", threshold: 0.2 };

      this.catalogoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.$refs.catalogoContainer.classList.add("show-catalog");
            this.catalogoObserver.disconnect();
          }
        });
      }, options);

      this.catalogoObserver.observe(this.$refs.catalogoSection);
    },

    /* ---------- botón de WhatsApp evita solaparse con el footer ---------- */
    observeFooter() {
      const footer = document.querySelector("footer");
      if (!footer) return;

      this.footerObserver = new IntersectionObserver(
        ([entry]) => {
          this.avoidFooter = entry.isIntersecting;
        },
        { root: null, threshold: 0.01 }
      );

      this.footerObserver.observe(footer);
    },
  },
};
</script>

<style scoped>
/* ------------------------------------------ */
/* 1. Carousel Caption: centrar verticalmente  */
.carousel-caption {
  top: 50%;
  bottom: auto;
  transform: translateY(-50%);
}

.carousel-caption h3 {
  font-family: "Playfair Display", serif;
  font-size: 4rem;
  font-weight: 500;
  color: #fff;
  text-shadow: 0 4px 8px rgba(0, 0, 0, 0.3), 0 3px 4px rgba(0, 0, 0, 0.4);
}

.carousel-caption p {
  font-family: "Playfair Display", serif;
  font-size: 1.5rem;
  font-weight: 500;
  color: #fff;
  text-shadow: 0 4px 8px rgba(0, 0, 0, 0.3), 0 3px 4px rgba(0, 0, 0, 0.4);
}

@media (max-width: 768px) {
  .carousel-caption h3 {
    font-size: 2rem;
  }

  .carousel-caption p {
    font-size: 1rem;
  }
}

@media (max-width: 576px) {
  .carousel-caption h3 {
    font-size: 1.5rem;
  }

  .carousel-caption p {
    font-size: 0.9rem;
  }
}

/* 2. Deslizador de marcas (Marquee) */
.brand-marquee {
  width: 100%;
  height: 62px;
  overflow: hidden;
  position: relative;
  margin-bottom: 0.1rem;
}

.marquee-track {
  display: flex;
  width: calc(200px * 6);
  animation: scrollLeft 55s linear infinite;
}

.marquee-track img {
  width: 1000px;
  height: auto;
  flex-shrink: 0;
}

@keyframes scrollLeft {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-1500px);
  }
}

/* CSS DEL CATALOGO*/
.catalogo-section {
  padding: 6rem 0;
  position: relative;
  overflow: hidden;
  margin-top: 3rem;
  /* Gradiente más suave y extenso */
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0.95) 5%,
    rgba(233, 236, 239, 0.8) 15%,
    rgba(233, 236, 239, 1) 25%,
    rgba(233, 236, 239, 1) 75%,
    rgba(233, 236, 239, 0.8) 85%,
    rgba(255, 255, 255, 0.95) 95%,
    rgba(255, 255, 255, 1) 100%
  );
}

.catalog-title-container {
  text-align: center;
  margin-bottom: 3rem;
  position: relative;
}

.catalog-title {
  font-family: "Playfair Display", serif;
  font-size: 2.6rem;
  color: #000000; /*Color titulo "Revisa nuestro catalogo"*/
  margin-bottom: 1rem;
  position: relative;
  display: inline-block;
}

.catalog-separator {
  position: relative;
  height: 2px;
  width: 200px;
  background-color: #00a9e0; /*Color subrayado titulo*/
  margin: 0 auto;
}

.catalog-icon {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: transparent; /* Cambiado para que no rompa el gradiente */
  padding: 0 15px;
  font-size: 1.5rem;
  color: #007bff;
}

.catalogo-container {
  max-width: 1000px;
  height: 80vh;
  margin: 0 auto;
  position: relative;
  perspective: 1500px;
  opacity: 0;
  transform: translateY(50px);
  transition: all 1.2s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.catalogo-container.show-catalog {
  opacity: 1;
  transform: translateY(0);
}

.book-container {
  width: 90%;
  height: 100%;
  margin: 0 auto;
  position: relative;
  transform-style: preserve-3d;
  transform: rotateY(-50deg) rotateX(50deg);
  transition: transform 1.8s ease;
  box-shadow: 20px 20px 30px rgba(0, 0, 0, 0.3);
  border-radius: 50px;
  overflow: hidden;
  /* Agregamos un sutil borde para integrar mejor con el fondo */
  border: 1px solid rgba(222, 226, 230, 0.5);
}

.book-container:hover {
  transform: rotateY(0deg) rotateX(0deg);
}

.book-shadow {
  position: absolute;
  width: 90%;
  height: 20px;
  bottom: -20px;
  left: 5%;
  background: rgba(0, 0, 0, 0.2);
  filter: blur(10px);
  border-radius: 50%;
  transform: scaleX(0.95);
  opacity: 0;
  transition: opacity 0.8s ease;
}

.catalogo-container.show-catalog .book-shadow {
  opacity: 0.8;
}

.pdf-viewer {
  width: 100%;
  height: 100%;
  background-color: white;
  border: none;
}

/* Estilo para el botón flotante de WhatsApp */
.whatsapp-float {
  position: fixed;
  bottom: 10px;
  right: 20px; /* Posicionado en la esquina inferior derecha */
  z-index: 1000; /* Asegura que esté por encima de otros elementos */
  transition: bottom 3s ease;
  animation: floating 3s ease-in-out infinite; /* Efecto de flotación */
}

/* Evita solaparse con el footer (desktop) */
.whatsapp-float.avoid-footer {
  bottom: 700px; /* tu valor para pantallas grandes */
}

/* Evita solaparse con el footer (móvil) */
@media (max-width: 768px) {
  .whatsapp-float.avoid-footer {
    bottom: 1000px; /* ajústalo al alto de tu footer en móvil */
  }
}

/* Efecto de flotación suave */
@keyframes floating {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0px);
  }
}

.whatsapp-float:hover {
  transform: scale(1.1);
}

/* AQUI CAMBIAS EL TAMAÑO DEL LOGO */
.whatsapp-icon {
  width: 65px;
  height: 65px;
  filter: drop-shadow(
    0 4px 4px rgba(0, 0, 0, 0.2)
  ); /* Sombra sutil para el PNG */
}

/* Media queries para responsive */
@media (max-width: 992px) {
  .book-container {
    width: 95%;
    transform: none;
  }

  .catalogo-container {
    height: 70vh;
  }

  /* AQUI CAMBIAS EL TAMAÑO DEL LOGO PARA TABLET */
  .whatsapp-icon {
    width: 60px;
    height: 60px;
  }
}

@media (max-width: 768px) {
  .catalogo-container {
    height: 60vh;
  }

  .catalog-title {
    font-size: 2rem;
  }

  .whatsapp-float {
    bottom: 15px;
    right: 15px;
  }

  /* AQUI CAMBIAS EL TAMAÑO DEL LOGO PARA MÓVIL MEDIANO */
  .whatsapp-icon {
    width: 55px;
    height: 55px;
  }
}

@media (max-width: 576px) {
  .catalogo-container {
    height: 50vh;
  }

  .catalog-title {
    font-size: 1.8rem;
  }

  .whatsapp-float {
    bottom: 10px;
    right: 10px;
  }

  /* AQUI CAMBIAS EL TAMAÑO DEL LOGO PARA MÓVIL PEQUEÑO */
  .whatsapp-icon {
    width: 50px;
    height: 50px;
  }

  @media (max-width: 992px) {
    .carousel-inner img {
      height: 50vh !important;
    }
  }

  @media (max-width: 768px) {
    .carousel-inner img {
      height: 40vh !important;
    }
  }

  @media (max-width: 576px) {
    .carousel-inner img {
      height: 30vh !important;
    }
  }
}
</style>
